import { User } from '@firebase/auth';
import { useStore } from '../store/store';

/**
 * Returns the current Firebase auth user.
 *
 * The auth listener lives at module scope in firebaseApp and writes the user
 * into the Zustand store. This hook simply subscribes to that store value, so
 * the user is available synchronously and persists across page navigation
 * instead of being re-resolved (and flickering through `null`) on every mount.
 */
export function useUser(): { user: User | null } {
  const user = useStore((state) => state.user);
  return { user };
}
